import { Flex, Text } from '@chakra-ui/react'
import { renderIcon } from '../TreeView.utils'
import React, { useCallback, useContext } from 'react'
import { TreeViewContext } from '../TreeViewContext'

export const TreeItemStatic = ({ data }) => {
  const { readOnly, onItemClick, selectedNodeId } = useContext(TreeViewContext)

  const handleItemClick = useCallback(() => {
    if (!readOnly) {
      onItemClick(data.id)
      if (onItemClick) onItemClick(data)
    }
  }, [readOnly, data, onItemClick])
  return (
    <Flex
      cursor="pointer"
      background={
        selectedNodeId === data.id ? 'brand.lightestGray' : 'transparent'
      }
      p="4px 24px"
      alignItems="center"
      onClick={handleItemClick}
      pointerEvents={readOnly ? 'none' : 'all'}
      opacity={readOnly ? 0.3 : 1}>
      {renderIcon(data.type)}
      <Text
        fontSize="14px"
        ml="8px"
        maxW="90%"
        textOverflow="ellipsis">
        {data.name}
      </Text>
    </Flex>
  )
}
